'use client'

import {ReactNode, forwardRef} from 'react'
import Link, {LinkProps} from 'next/link' // Removed unused LinkProps import
import {useGameLink} from './use-game-link'
import {ReffererLayout} from '@app/analytics/analytics-provider/types'

type LinkTagProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & LinkProps

interface Props extends Omit<LinkTagProps, 'href'> {
  gameCode: string
  gameName: string
  children: ReactNode
  propertyCode: string
  reffererLayout?: ReffererLayout
}

export const interalNavigationQuery = {'int-nav': '1'}

const GameLink = forwardRef<HTMLAnchorElement, Props>(
  ({gameCode, gameName, children, propertyCode, reffererLayout, ...restProps}, ref) => {
    const {route, query, isExtendedCanonical} = useGameLink({
      gameCode,
      gameName,
      propertyCode,
      reffererLayout,
    })

    return (
      <Link
        {...restProps}
        ref={ref}
        href={{
          pathname: route,
          query: isExtendedCanonical ? {} : query,
        }}
        scroll={true}
        prefetch={false}
      >
        {children}
      </Link>
    )
  },
)

GameLink.displayName = 'GameLink'

export default GameLink
